var map = {
	"./main-popup.png": 6868,
	"./main-promotion-banner1-mo.png": 7180,
	"./main-promotion-banner1.png": 6477,
	"./main-promotion-banner2-mo.png": 501,
	"./main-promotion-banner2.png": 5798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4921;